export const addAuctionAuctioneer = /* GraphQL */ `
  mutation AddAuctionAuctioneer($auctionId: ID!, $accountId: ID!) {
    addAuctionAuctioneer(auctionId: $auctionId, accountId: $accountId) {
      status
      code
      message
      auctionId
      accountId
    }
  }
`;

export const deleteAuctionAuctioneer = /* GraphQL */ `
  mutation DeleteAuctionAuctioneer($auctionId: ID!, $accountId: ID!) {
    deleteAuctionAuctioneer(auctionId: $auctionId, accountId: $accountId) {
      status
      code
      message
      auctionId
      accountId
    }
  }
`;
